import { create } from 'zustand';
import type { KycState, KycStep, KycStatus, KycDecision } from '../types/kyc';

interface KycStore extends KycState {
  // Actions
  setStep: (step: KycStep) => void;
  setCase: (caseId: string, attemptId: string) => void;
  setLivenessSession: (sessionId: string) => void;
  setStatus: (status: KycStatus) => void;
  setResult: (decision: KycDecision, extractedName?: string, rejectionReason?: string, canRetry?: boolean) => void;
  setError: (error: string | null) => void;
  setLoading: (isLoading: boolean) => void;
  reset: () => void;
}

const initialState: KycState = {
  step: 'loading',
  caseId: null,
  attemptId: null,
  userId: `user-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
  livenessSessionId: null,
  status: null,
  decision: null,
  extractedName: null,
  rejectionReason: null,
  canRetry: false,
  error: null,
  isLoading: false,
};

export const useKycStore = create<KycStore>((set) => ({
  ...initialState,

  setStep: (step) => set({ step }),

  setCase: (caseId, attemptId) => set({ caseId, attemptId }),

  setLivenessSession: (sessionId) => set({ livenessSessionId: sessionId }),

  setStatus: (status) => set({ status }),

  setResult: (decision, extractedName, rejectionReason, canRetry = false) =>
    set({ decision, extractedName, rejectionReason, canRetry }),

  setError: (error) => set({ error }),

  setLoading: (isLoading) => set({ isLoading }),

  reset: () => set({
    ...initialState,
    userId: `user-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
  }),
}));


